wbApp.directive('wbPaymentReservationCombo', ['$timeout',
    function ($timeout) {
        function formatSelection(reservation) {
            if (!reservation) { return ""; }
                return reservation.invoice.subject;
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                wbReservations: '='
            },
            link: function (scope, elm, attrs, ngModel) {

                $timeout(function () {
                    $(elm).select2({
                        id: function (data) { return data.id; },
                        formatResult: formatSelection,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        data: scope.wbReservations 
                    });

                    ngModel.$render = function () {
                        elm.select2('val', ngModel.$viewValue);
                    };

                    elm.on('change', function () {
                        scope.$apply(function () {
                            ngModel.$setViewValue(elm.select2('val'));
                        });
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });
                }, 1);
            }
        }
    }]);